// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"2265":"canvg","4297":"xlsx","5034":"52ce7c66","6890":"08a9aade","7236":"6e9e037d","9594":"d545ab8d"}[chunkId] + "." + {"2265":"4f89af1713fddb72","4297":"34bd765e10ce5090","5034":"6dc1c06fbd91e8e3","6890":"b75fb8e4229b8401","7236":"f37648e5b07c5989","9594":"bc23a8b26759ad65"}[chunkId] + ".js";
};